import React, { useContext } from "react";
import ParamsContext from "../../context/ParamsContext";

const TryonResult = () => {
  const { tryonData } = useContext(ParamsContext);
  return (
    <>
      {tryonData && <img className="aspect-[2/2.5] w-full object-contain" src={tryonData} alt="tryon" />}
    </>
  );
};

export default TryonResult;
